export default "__VITE_ASSET__ClaYiR$W__"